import type businessDocumentItemVM from "../../../BusinessDocuments/BusinessDocumentItemSelector/businessDocumentItemVM";
import type { ServerProductReturnRequestItemVM } from "./ServerComplaintItemVM";

/// Client-side VM for product return request item, which is different from the one in the server side
export interface ProductReturnRequestItemViewModel {
  /** Unique identifier for the product return request item used only on the client side, to track it during the editing process */
  id: string;
  documentItem: businessDocumentItemVM | null;
  amount: number | null;
  comments: string | null;
}

export function productReturnRequestItemViewModelToServerModel(
  item: ProductReturnRequestItemViewModel
): ServerProductReturnRequestItemVM {
  return {
    // biome-ignore lint/style/noNonNullAssertion: at the point when the conversion is called, the documentItem should have been selected, so it's safe to use non-null assertion here.
    lineCode: item.documentItem?.lineCode!,
    // biome-ignore lint/style/noNonNullAssertion: at the point when the conversion is called, the documentItem should have been selected, so it's safe to use non-null assertion here.
    productName: item.documentItem?.productName!,
    // biome-ignore lint/style/noNonNullAssertion: at the point when the conversion is called, the documentItem should have been selected, so it's safe to use non-null assertion here.
    catalogNumber: item.documentItem?.catalogNumber!,
    amount: item.amount,
    comments: item.comments
  }
}
